import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ClientNotifier, IBasicCommandResponse } from "../../scripts/ah.mb.client-notifications";
import { DbAdminServices } from "../../scripts/ah.mb.dbadmin-services";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { MessageBox } from "uiv";


@Component
export default class DbAdminIndex extends Vue {

    private services = new DbAdminServices();

    isBusy: boolean = false;

    // Create user notifier
    private userNotifier = new ClientNotifier();


    updateIndexes() {
        //                                 data-objectId="@Url.Action(" UpdateIndexes", "DatabaseAdminApi" )">

        const notification = this.userNotifier.showNotification("Updating indexes...", true, true);
        this.isBusy = true;
        this.services.updateIndexes()
            .finally(() => {
                this.userNotifier.clear(notification);
                this.isBusy = false;
            });
    }


    deleteAllModels() {

        //                                 data-objectid="@Url.Action(" DeleteAllModels", "DatabaseAdminApi" )"
        bootbox.confirm("Delete all models?  This cannot be undone.",
            ok => {
                if (ok) {
                    const notification = this.userNotifier.showNotification("Deleting all models...", true, true);
                    this.isBusy = true;
                    this.services.deleteAllModels()
                        .then(data => {
                            this.userNotifier.showNotification(data.response, data.success, false);
                        })
                        .finally(() => {
                            this.userNotifier.clear(notification);
                            this.isBusy = false;

                        });

                };
            });


    }

    setDbPrefix() {
        //                                 data-objectid="@Url.Action(" SetDbPrefix", "DatabaseAdminApi" )"


        FetchWrapper.fetch("/api/1.0/dbadmin/getdbprefix", { method: "get" })
            .then(response => response.json())
            .then(response => {
                bootbox.prompt({
                    title: "New database prefix",
                    content: response.result,
                    callback: result => {
                        if (result) {
                            this.changeDbPrefix(result);
                        }
                    }
                });
            });

    }

    changeDbPrefix(value): Promise<IBasicCommandResponse> {

        return FetchWrapper.sendCommandAndHandle("/api/1.0/dbadmin/setdbprefix",
            {
                method: "post",
                body: JSON.stringify({ dbPrefix: value })
            });
    }


    upgradeModelDatabases() {
        this.isBusy = true;
        var notification = this.userNotifier.showNotification("Upgrading database...", true, true);

        this.services.performDbUpgrades("", true)
            .then(response => {

                var title = `Upgrade Database`;

                MessageBox.confirm({
                    title: title, content: `${response.response}, show more information?`
                })
                    .then(() => {
                        var moreInfo = JSON.stringify(response);
                        MessageBox.alert({ title: title, content: moreInfo, size: "lg", html: false }, () => { });

                    })

                //bootbox.alert(response.response);
            })
            .finally(() => {
                this.isBusy = false;
                this.userNotifier.clear(notification);
            }
            );

    }

    upgradeSystemDatabase() {

        this.isBusy = true;
        var notification = this.userNotifier.showNotification("Upgrading database...", true, true);

        this.services.performDbUpgrades("", false)
            .then(response => {

                var title = `Upgrade Database`;

                MessageBox.confirm({
                    title: title, content: `${response.response}, show more information?`
                })
                    .then(() => {
                        var moreInfo = JSON.stringify(response);
                        MessageBox.alert({ title: title, content: moreInfo, size: "lg", html: false }, () => { });

                    })

                //bootbox.alert(response.response);
            })
            .finally(() => {
                this.isBusy = false;
                this.userNotifier.clear(notification);
            });
    }


    seedUsers() {

        this.isBusy = true;
        var notification = this.userNotifier.showNotification("Seeding users...", true, true);

        this.services.seedUsers()
            .then(response => {
                var splitStr = response.response.replace(/(?:\r\n|\r|\n)/g, '<br>')
                MessageBox.alert({ title: `Seed Users`, content: splitStr, size: "lg", html: true }, () => { });
            })
            .finally(() => {
                this.isBusy = false;
                this.userNotifier.clear(notification);
            });
    }


    mounted() {
        // Update indexes button click handler


        // Set node type button click
        $(
            '#setNodeTypeFieldButton').click(
                (e) => {
                    var url = $(e.currentTarget as Element).attr("data-url");
                    this.userNotifier.showNotification("Setting node type fields...", true, true);
                    this.services.setNodeTypeField(url)
                        .then(data => { bootbox.alert(data.response); });

                });



        // Tag Categories button click
        $(
            '#tag-categories-btn').click(
                e => {
                    const url = $(e.currentTarget as Element).attr("data-url");
                    this.$router.push("/admin/tagcategories");
                });
    }

    executeCommand() {


        bootbox.prompt({
            content: "", title: "Enter command name", callback:
                commandName => {
                    if (commandName) {

                        bootbox.prompt({
                            content: "{}", title: "Enter command content", callback:
                                payload => {
                                    try {
                                        let obj = JSON.parse(payload);
                                        this.isBusy = true;

                                        var notification = this.userNotifier.showNotification(`Executing ${commandName} command`, true, true);

                                        FetchWrapper.sendCommandAndHandle(`/api/1.0/command/${commandName}`,
                                            { method: "post", body: JSON.stringify(obj) })
                                            .finally(() => {
                                                this.userNotifier.clear(notification);
                                                this.isBusy = false;
                                            });
                                    }

                                    catch (e) {
                                        bootbox.alert((e as Error).message, () => { });
                                    }
                                }
                        })

                    }

                }
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/db-admin/db-admin-index.ts